<template>
	<b-popover
		:target="target"
		triggers="click"
		:show.sync="showContextMenu"
		placement="auto"
		container="my-container"
		ref="popover"
		@cancel="onClose"
		@hidden="onClose"
		class="p-0"
		custom-class="invoice-popover"
	>
		<slot v-if="$slots.content" name="content"></slot>
		<div else style="max-width: 20rem">
			<b-list-group>
				<b-list-group-item @click="openFileExplorer" class="cursor-pointer d-flex justify-content-between align-items-center">
					{{ FormMSG(1, 'Photo Library') }}
					<component :is="getLucideIcon('Folder')" :size="20" color="#59c1bf" :stroke-width="1.5" />
				</b-list-group-item>
				<b-list-group-item @click="takePhoto" class="cursor-pointer d-flex justify-content-between align-items-center">
					{{ FormMSG(2, 'Take photo') }}
					<component :is="getLucideIcon('Camera')" :size="20" color="#59c1bf" :stroke-width="1.5" />
				</b-list-group-item>
				<slot name="menu"></slot>
			</b-list-group>
		</div>
	</b-popover>
</template>

<script>
// mixin
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';
import invoicesToolsMixin from '@/mixins/invoicesTools.mixin';

export default {
	name: 'InvoiceContextMenu',
	mixins: [languageMessages, globalMixin, invoicesToolsMixin],
	props: {
		target: {
			type: String,
			default: ''
		},
		show: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showContextMenu: false,
			menuX: 0,
			menuY: 0,
			windowWidth: window.innerWidth,
			isShowContextMenu: false,
			defaultTextArea: '',
			cursor: 0
		};
	},
	methods: {
		onClose() {
			this.$emit('close');
		},
		takePhoto() {
			this.$emit('take-photo');
		},
		openFileExplorer() {
			this.$emit('open-file-explorer');
		}
	},
	watch: {
		show: {
			handler(newVal) {
				console.log('show', newVal);
				this.showContextMenu = newVal;
			},
			immediate: true,
			deep: true
		}
	}
};
</script>

<style lang="scss">
.invoice-popover {
	z-index: 9999;
	width: 200px;
	.popover-body {
		padding: 0;
	}
}
</style>
